import { combineReducers } from "redux";

import Common from "appRedux/reducers/Common";
import Auth from "appRedux/reducers/Auth";
import Permissions from "appRedux/reducers/Permissions";
import Countries from "appRedux/reducers/Countries";
import Roles from "appRedux/reducers/Roles";
import Individuals from "appRedux/reducers/Individuals";

import SelectOperatorToken from "containers/BuyOperatorToken/reducer";
import Search from "containers/Dashboard/reducer";
import BuyOperatorToken from "containers/BuyOperatorDualView/reducer";
import Transaction from "appRedux/reducers/Transaction";
import Token from "appRedux/reducers/Token";
import SystemTransaction from "appRedux/reducers/SystemTransaction";
import Operators from "appRedux/reducers/Operators";
import History from "appRedux/reducers/History";
import Admin from "appRedux/reducers/Admin";
import Route from "appRedux/reducers/Routs";
import logoReducer from "appRedux/reducers/logo";
import routesReducer from "./TransportRoute";

const reducers = combineReducers({
  common: Common,
  auth: Auth,
  admin: Admin,
  transaction: Transaction,
  token: Token,
  history: History,
  systemTransaction: SystemTransaction,
  permission: Permissions,
  role: Roles,
  route: Route,
  country: Countries,
  individual: Individuals,
  operator: Operators,
  selectOperatorState: SelectOperatorToken,
  searchState: Search,
  buyOperatorState: BuyOperatorToken,
  logo: logoReducer,
  transportRoute: routesReducer,
});

export default reducers;
